import { Settings } from '@/features/shared/models/Settings';

export const ISettingsServiceId = Symbol.for('ISettingsService');

export interface ISettingsService {
    getSettings(): Promise<Settings>;
}
